// Angular
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

// Third-party libraries
import { CookieService } from 'ngx-cookie-service';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideToastConfig, ToastService } from '@sms-ir/ui-components';

import { ngxMaskConfig } from '@app/core/config/ngx-mask.config';

// App services
import { EncryptionService, LayoutService, SidebarMenuService, StorageService, TokenService } from '@app/core/services';
import { ThemeService } from '@app/core/services/theme.service';

// App API
import { ApiExecutor, ApiValidationService } from '@app/core/api';

// App interceptors
import { apiResponseInterceptor, authInterceptor } from '@app/core/interceptors';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';

/**
 * Core providers for the application
 * This replaces the old CoreModule.forRoot() pattern
 */
export const coreProviders = [
  provideEnvironmentNgxMask(ngxMaskConfig),
  provideHttpClient(
    withInterceptors([
      authInterceptor,
      apiResponseInterceptor,
    ])
  ),
  provideAnimationsAsync(),
  provideToastConfig({ duration: 4000, position: 'top-right', maxStack: 5 }),
  ToastService,
  CookieService,
  StorageService,
  EncryptionService,
  TokenService,
  ApiExecutor,
  ApiValidationService,
  SidebarMenuService,
  LayoutService,
  ThemeService,
];

